export default "__VITE_ASSET__0d5d12dd__"